"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioContext = exports.setAudioContextUnlocked = void 0;
const _AudioContext = window.AudioContext || window.webkitAudioContext || null;
let unlockedAudioContext = false;
const setAudioContextUnlocked = () => {
    unlockedAudioContext = true;
};
exports.setAudioContextUnlocked = setAudioContextUnlocked;
class WrappedAudioContext extends _AudioContext {
    constructor(contextOptions) {
        super(contextOptions);
    }
    async resume() {
        if (!unlockedAudioContext) {
            console.error("Failed to resume, AudioContext is potentially locked and could hang indefinitely. Use dangerouslyResumeEvenIfLocked() if you're sure AudioContext is unlocked");
            return;
        }
        return super.resume();
    }
    async suspend() {
        if (!unlockedAudioContext) {
            console.error("Failed to suspend, AudioContext is potentially locked and could hang indefinitely. Use dangerouslySuspendEvenIfLocked() if you're sure AudioContext is unlocked");
            return;
        }
        return super.suspend();
    }
    async dangerouslyResumeEvenIfLocked() {
        return super.resume();
    }
    async dangerouslySuspendEvenIfLocked() {
        return super.suspend();
    }
}
exports.AudioContext = _AudioContext ? WrappedAudioContext : null;
//# sourceMappingURL=AudioContext.js.map